/**
 * Include / exclude a person from the tree Legacy Book (archive profile unchanged).
 */
import React, { useState } from 'react';
import axios from 'axios';
import { BookOpen } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { getApiBase } from '../../utils/apiBase';
import { humanizeError } from '../../utils/errorHandling';

const API = getApiBase();

export function LegacyBookPersonSetting({ person, canEdit, onUpdated }) {
  const included = person?.include_in_legacy_book !== false;
  const [saving, setSaving] = useState(false);

  if (!person?.id || !canEdit) return null;

  const handleToggle = async (checked) => {
    setSaving(true);
    try {
      const response = await axios.put(`${API}/individuals/${person.id}`, {
        include_in_legacy_book: checked,
      });
      onUpdated?.(response.data);
      toast.success(checked ? 'Included in Legacy Book' : 'Left out of Legacy Book');
    } catch (error) {
      toast.error(humanizeError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="rounded-xl border border-[#e8e2d8]/90 bg-[#fffdf8]/80 px-4 py-3"
      data-testid="legacy-book-person-setting"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 gap-3">
          <BookOpen className="mt-0.5 h-4 w-4 shrink-0 text-[#8b7355]" aria-hidden />
          <div>
            <Label htmlFor="include-in-legacy-book" className="text-sm font-medium text-[#2c2824]">
              Include in Legacy Book
            </Label>
            <p className="mt-1 text-xs leading-relaxed text-[#6c6258]">
              Keep this person in your archive, but leave them out of this Legacy Book.
            </p>
          </div>
        </div>
        <Switch
          id="include-in-legacy-book"
          checked={included}
          disabled={saving}
          onCheckedChange={handleToggle}
          data-testid="include-in-legacy-book-switch"
          aria-label="Include in Legacy Book"
        />
      </div>
    </div>
  );
}

export default LegacyBookPersonSetting;
